import React from "react";
import { graphql, Link as GatsbyLink } from "gatsby";
import Link from "../components/Link";

import Layout from "../components/Layout";
import WithI18next from "../components/WithI18next";
import { isShowSupportCategory } from "../utils";

const SupportCenterCategoryPage = ({ data, t, lang }) => {
  return (
    <Layout
      title={`${data.currentCat.edges[0].node.name} | ${t(
        "support.seo.title"
      )}`}
      description={t("support.seo.description")}
    >
      <div className="pt-5">
        <div className="container mb-5">
          <div className="row">
            <div className="col-lg-3">
              <div className="sidebar">
                <ul className="sidebar-menu">
                  {data.cats.edges.map(
                    (post, i) =>
                      isShowSupportCategory(
                        post.node.acfCategories.catShowOnCountries,
                        lang
                      ) && (
                        <li key={`support-category-${i}`}>
                          <GatsbyLink
                            activeClassName="active"
                            partiallyActive={true}
                            to={`../${post.node.slug}/`}
                          >
                            {post.node.name}
                          </GatsbyLink>
                        </li>
                      )
                  )}
                </ul>
              </div>
            </div>
            <div className="col-lg-9 page-content">
              <p className="mb-5 sc-breadcrumb">
                <Link to="/support/">{t("support.supportCenter")}</Link> {">"}{" "}
                <span>{data.currentCat.edges[0].node.name}</span>
              </p>

              <h1
                className="mb-5"
                dangerouslySetInnerHTML={{
                  __html: data.currentCat.edges[0].node.name,
                }}
              />
              <ul className="scq-list">
                {data.currentCatData.edges.map((post, i) => (
                  <li key={`scq-list-${i}`}>
                    <GatsbyLink to={`${post.node.slug}/`}>
                      <h5
                        dangerouslySetInnerHTML={{ __html: post.node.title }}
                      />
                    </GatsbyLink>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="cta mt-auto">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 text-center">
              <h2 className="mb-4">{t("support.cantFind")}</h2>
              <Link
                role="button"
                to={"/contact-us/"}
                className="btn btn-primary mb-2"
              >
                {t("support.btnContactUs")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default WithI18next()(SupportCenterCategoryPage);

export const query = graphql`
  query ($id: Int!, $wpLocale: String!, $wpGlobalConfig: String!) {
    currentCat: allWpCategory(
      filter: {
        databaseId: { eq: $id }
        language: { locale: { eq: $wpLocale } }
      }
    ) {
      edges {
        node {
          name
        }
      }
    }
    currentCatData: allWpSupportCenterItem(
      filter: {
        acfGlobalConfiguration: { gcLinkTo: { in: [$wpGlobalConfig, ".all"] } }
        language: { locale: { eq: $wpLocale } }
        categories: { nodes: { elemMatch: { databaseId: { eq: $id } } } }
      }
    ) {
      edges {
        node {
          title
          slug
          categories {
            nodes {
              name
            }
          }
        }
      }
    }
    cats: allWpCategory(
      sort: { order: ASC, fields: acfCategories___catCategoryOrder }
      filter: {
        language: { locale: { eq: $wpLocale } }
        acfCategories: { catShowOnGraphql: { eq: "1" } }
      }
    ) {
      edges {
        node {
          name
          slug
          acfCategories {
            catShowOnCountries
          }
        }
      }
    }
  }
`;
